import { stdObject } from "../data/types/stdObject";

export const processPersonsData = (type: string, list: stdObject[]) =>
  list.map((e: stdObject) => {
    e[`DOM${type.toUpperCase()}`] = JSON.parse(
      e[`DOM${type.toUpperCase()}`],
    ).filter((v: stdObject) => v.DOMDIR);
    return e;
  });
